import { AgoraEntity } from '../../../../../core/models/configuration-system/agora-entity';

const iconsOfActionsList = [
  {
    icon: 'edit',
    tooltip: 'editar',
    hasVisibleCondition: (element: AgoraEntity[]): boolean => element.length >= 1
  }
];

export const agoraShop = {
    searchText: 'Buscar configuración por sucursal',
    addText: 'Configuración',
    export: false,
    dialogHability: true,
    filter: false,
    checkbox: true,
    checkboxHeader: false,
    disabled: false,
    partialField: '',
    iconsOfActions: iconsOfActionsList,
    hasDisabledCheckBoxItem: (row: AgoraEntity, selection: AgoraEntity[]) => {
      if (selection.length > 0 && row) {
        return selection.length === 1 && row.companyCode === selection[0].companyCode ? false : true;
      } else {
        return false;
      }
    },
    columns: [
      {
        title: 'Empresa',
        name: 'companyCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: AgoraEntity) => element.companyCode
      },
      {
        title: 'Entidad',
        name: 'entityCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: AgoraEntity) => element.entityCode
      },
      {
        title: 'ID Tienda',
        name: 'storeId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: AgoraEntity) => element.storeId
      },
      {
        title: 'ID Sucursal',
        name: 'subsidiaryId',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: AgoraEntity) => element.subsidiaryId
      },
      {
        title: 'Activo',
        name: 'active',
        type: 'boolean',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: AgoraEntity) => element.active
      },
      {
        title: 'Enviar a Agora',
        name: 'isSendAgora',
        type: 'boolean',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: AgoraEntity) => element.isSendAgora
      },
      {
        title: 'Enviar actualización online',
        name: 'isSendUpdateOnline',
        type: 'boolean',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: AgoraEntity) => element.isSendUpdateOnline
      },
      {
        title: 'Solo a stock centralizado',
        name: 'onlyToCentralizedStock',
        type: 'boolean',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: AgoraEntity) => element.onlyToCentralizedStock
      }
    ]
  };